import React, { useState, useEffect, useContext } from 'react';
import { OwnerContext } from "../../context/OwnerContext";
import OwnerLayout from "./OwnerLayout";
import NotificationsBell from "../commons/NotificationsBell";

const OwnerDashboard = () => {
    const { owner, loading, error } = useContext(OwnerContext);

    if (loading) {
        return <div>Ładowanie...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    const welcomeName = `${owner.firstName} ${owner.lastName}`;

    return (
        <OwnerLayout>
            <div className="page-container">
                <div className="dashboard-header">
                    <div className="header-left">
                        <h1>Witaj, {welcomeName}!</h1>
                    </div>
                    <div className="header-right">
                    </div>
                </div>
            </div>
        </OwnerLayout>
    );
};

export default OwnerDashboard;